/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CampaignUnarchivePathParams, CampaignUnarchiveResponse } from '../types/CampaignUnarchive'

/**
 * POST /campaigns/:campaign/unarchive
 * @see backend/nexus/modules/Campaign/Http/Controllers/CampaignController.php CampaignController::unarchive
 */
export async function campaignUnarchive(
	campaign: CampaignUnarchivePathParams['campaign'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignUnarchiveResponse>> {
	return axiosInstance.post(`/campaigns/${campaign}/unarchive`, undefined, config)
}
